import * as React from 'react'
import { FieldGroup, renderFieldsSimple, textAreaInputFieldComponent } from '@shared/components/forms'
import { emptyValidator } from '@shared/helpers'
import styled from 'styled-components'

const StyledRequestFeatureForm = styled.div``

function requestFormFields(): FieldGroup<any> {
  return [
    {
      name: 'request',
      label: 'Describe your requested feature',
      required: true,
      placeholder: 'Request',
      validate: emptyValidator,
      component: textAreaInputFieldComponent(),
    },
  ]
}

export const RequestAFeatureForm = () => {
  return (
    <StyledRequestFeatureForm>
      {renderFieldsSimple(requestFormFields())}
    </StyledRequestFeatureForm>
  )
}
